import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ListItemAction, TeamsService, UsersService } from '../../generated';
import type { WorkspaceItem } from '../user/user.types';
import { useUserKey } from '../user/user.hooks';
import { useTeamKey } from '../team/team.hooks';

export type UpdateFlittPaymentInput = {
    provider: 'flitt';
    merchant_id?: string;
    secret_key?: string;
};

export type UpdateAmeriaPaymentInput = {
    provider: 'ameriabank';
    client_id?: string;
    username?: string;
    password?: string;
};

export const useUpdatePaymentGateway = (workspace?: WorkspaceItem) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (
            items: UpdateFlittPaymentInput | UpdateAmeriaPaymentInput
        ) => {
            if (!workspace || workspace.individual) {
                const response = await UsersService.updatePaymentGatewayUsers({
                    body: {
                        items: [
                            { reference: items, action: ListItemAction.ADD },
                        ],
                    },
                });

                if (!response.data)
                    throw new Error(
                        `Failed to update payment gateway for ${items.provider}`
                    );

                return response.data;
            }
            const response = await TeamsService.updatePaymentGatewayTeams({
                body: {
                    items: [{ reference: items, action: ListItemAction.ADD }],
                },
                path: {
                    team_id: workspace.id,
                },
            });

            if (!response.data)
                throw new Error(
                    `Failed to update payment gateway for ${items.provider}`
                );

            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [useUserKey] });
            queryClient.invalidateQueries({ queryKey: [useTeamKey] });
        },
    });
};
